import { routeUrlObj } from './mapRouteUrl';

export const redirection = (data) => {
  const { redirect_to = "" } = data.data
  if (redirect_to && redirect_to.length) {
    return redirect_to.toString().trim()
  }
  return "";
}

export const getCityName = (src) => {
  const srcWithoutSpace = src ? src.replace(/%20/g, " ").toString().toLowerCase().trim() : '';
  let redirectSrc = "";
  if (srcWithoutSpace in routeUrlObj) {
    redirectSrc = routeUrlObj[srcWithoutSpace] ? routeUrlObj[srcWithoutSpace] : srcWithoutSpace;
  }

  if (redirectSrc === src) {
    redirectSrc = "";
  }
  return redirectSrc;
}

export const getSrcDestName = (src, dest) => {
  const srcWithoutSpace = src ? src.replace(/%20/g, " ").toString().toLowerCase().trim() : '';
  const destWithoutSpace = dest ? dest.replace(/%20/g, " ").toString().toLowerCase().trim() : '';

  let redirectSrc = "", redirectDest = "";
  if (srcWithoutSpace in routeUrlObj || destWithoutSpace in routeUrlObj) {
    redirectSrc = routeUrlObj[srcWithoutSpace] ? routeUrlObj[srcWithoutSpace] : srcWithoutSpace;
    redirectDest = routeUrlObj[destWithoutSpace] ? routeUrlObj[destWithoutSpace] : destWithoutSpace;
  }

  if (redirectSrc === src && redirectDest === dest) {
    redirectSrc = "";
    redirectDest = "";
  }
  return { redirectSrc, redirectDest };
}
